import { useEffect, useMemo, useState } from 'react'

import { useRouter } from 'next/router'

import { Hero, Locale } from '@/service/api/landingPageB'
import { useScreen } from '@/store/screen'
import { getLPTranslationData } from '@/utils/getLPTranslationData'

export const useHero = () => {
  const { windowSize } = useScreen()

  const router = useRouter()

  const locale = (router.locale || 'pt-BR') as Locale

  const [heroData, setHeroData] = useState<Hero>(
    () =>
      getLPTranslationData({
        landingPage: 'entre-em-contato',
        container: 'heroContainer',
        locale,
      }) as Hero,
  )

  useEffect(() => {
    const translationsObject = getLPTranslationData({
      landingPage: 'entre-em-contato',
      container: 'heroContainer',
      locale,
    }) as Hero

    setHeroData(translationsObject)
  }, [locale])

  const fontSizeByScreenSize = useMemo(() => {
    const fontsSizesByScreen = {
      1440: {
        title: 'h2' as const,
      },
      900: {
        title: 'h3' as const,
      },
      700: {
        title: 'h5' as const,
      },
    }
    return fontsSizesByScreen
  }, [])

  const { width } = windowSize
  const fontSizes = useMemo(() => {
    if (!width) return fontSizeByScreenSize[1440]
    if (width <= 700) return fontSizeByScreenSize[700]
    if (width <= 900) return fontSizeByScreenSize[900]

    return fontSizeByScreenSize[1440]
  }, [width, fontSizeByScreenSize])

  return {
    fontSizes,
    heroData,
  }
}
